import { useUserStore } from '~/stores/userStore'
import { DocumentStagingStatus } from '~/types/document.types'
import { StagingStatusLabels } from '~/types/feEnumLabels'
import { UserRole } from '~/types/user.types'

type StagingStatusOption = {
  label: string
  value: DocumentStagingStatus
}

export const useAvailableStagingStatuses: (
  currentStatus?: DocumentStagingStatus,
) => StagingStatusOption[] = (currentStatus) => {
  const userStore = useUserStore()
  const user = userStore.user

  if (!user || typeof currentStatus === 'undefined') return []

  const isGlobalAdmin = user.role >= UserRole.Admin
  const availableStatuses: DocumentStagingStatus[] = [currentStatus]

  if (isGlobalAdmin) {
    // Admins can move forward through all stages or reset to PendingUpload
    switch (currentStatus) {
      case DocumentStagingStatus.PendingUpload:
        break
      case DocumentStagingStatus.Draft:
        availableStatuses.push(DocumentStagingStatus.InternalReview)
        break
      case DocumentStagingStatus.InternalReview:
        availableStatuses.push(DocumentStagingStatus.ConsultantReview)
        availableStatuses.push(DocumentStagingStatus.AuditReady)
        availableStatuses.push(DocumentStagingStatus.Final)
        break
      case DocumentStagingStatus.ConsultantReview:
        availableStatuses.push(DocumentStagingStatus.InternalReview)
        availableStatuses.push(DocumentStagingStatus.AuditReady)
        availableStatuses.push(DocumentStagingStatus.Final)
        break
      case DocumentStagingStatus.AuditReady:
        availableStatuses.push(DocumentStagingStatus.InternalReview)
        availableStatuses.push(DocumentStagingStatus.ConsultantReview)
        availableStatuses.push(DocumentStagingStatus.Final)
        break
      case DocumentStagingStatus.Final:
        break
    }

    // Admins can always set back to PendingUpload unless it's already PendingUpload
    if (!availableStatuses.includes(DocumentStagingStatus.PendingUpload)) {
      availableStatuses.push(DocumentStagingStatus.PendingUpload)
    }
  } else {
    // Non-admins can only move from Draft to InternalReview
    if (currentStatus === DocumentStagingStatus.Draft) {
      availableStatuses.push(DocumentStagingStatus.InternalReview)
    }
  }

  // map availableStatuses to StagingStatusOption
  return availableStatuses.map((status) => ({
    label: StagingStatusLabels[status],
    value: status,
  }))
}
